var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alertModal',{attrs:{"modalType":"simple","isModalShown":_vm.tipLogin,"modalTitle":_vm.tipName},on:{"cancel":_vm.isCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }